import styled from 'styled-components'

export const ChosenStudent = styled.span`
  font-weight: bold;
  opacity: 0.7;
  @media (max-width: 767px) {
    font-size: 12px;
  }
`
